//css
import './app.css';
//js
import React, { useContext } from 'react';
import { StateContext } from 'context';
import { SnackbarProvider } from 'notistack';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import "moment/locale/es";
/* componentes */
import { Loading } from 'components/w3';
/* páginas */
import { Main } from 'app/main';

const App = props => {
    const state = useContext(StateContext);
    const notistackRef = React.createRef();
    const onClickDismiss = key => () => {
        notistackRef.current.closeSnackbar(key);
    }
    return (
        <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            ref={notistackRef}
            action={(key) => (
                <IconButton aria-label="cerrar" onClick={onClickDismiss(key)}>
                    <FontAwesomeIcon icon={faTimes} color={'#ffffff'} size="xs" />
                </IconButton>
            )}>
            <>
                {state.appReducer.loading ? <Loading fondo='rgba(0,0,0,0.2)' /> : ''}
                <Main />
                {/* <Routes>
                    <Route path="/" element={<Main />} />
                </Routes> */}
            </>
        </SnackbarProvider>

    );
}
export default App;